var _g, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0427\\u0430\\u0441\\u044B",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24.8 24.8",
    style: {
      enableBackground: "new 0 0 24.8 24.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_71"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4,
    cy: 12.4,
    rx: 11.9,
    ry: 11.9,
    fill: "none",
    stroke: "current"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    d: "M12.4,4v10.3l5.1,5.2",
    strokeLinecap: "round",
    fill: "none",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.b739a04b4b88f940944b0417c276b2a4.svg";
export { ForwardRef as ReactComponent };